import { render, staticRenderFns } from "./MyShipment.vue?vue&type=template&id=3ce89020&scoped=true&"
import script from "./MyShipment.vue?vue&type=script&lang=js&"
export * from "./MyShipment.vue?vue&type=script&lang=js&"
import style0 from "./MyShipment.vue?vue&type=style&index=0&id=3ce89020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce89020",
  null
  
)

export default component.exports